<template>
  <v-container class="pr-0 pl-0 mb-16" fluid>
    <!-- Row to organize insights in cards -->
    <v-row>

      <v-col cols="12" v-for="item in userWithTreinosByCount100" :key="item.id">
        <v-card class="elevation-10" :disabled="dialogLoader">
          <v-card-text class="body-2">
            <v-icon left color="primary">mdi-emoticon-cool-outline</v-icon>{{ item.fullName }}
            tem seu <span class="font-weight-black">100º</span> treino conosco hoje! Dê os parabéns! 
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-for="item in userWithTreinosByCount500" :key="item.id">
        <v-card class="elevation-10" :disabled="dialogLoader">
          <v-card-text class="body-2">
            <v-icon left color="primary">mdi-emoticon-cool-outline</v-icon>{{ item.fullName }}
            tem seu <span class="font-weight-black">500º</span> treino conosco hoje! Dê os parabéns! 
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" v-for="item in userWithTreinosByCount1000" :key="item.id">
        <v-card class="elevation-10" :disabled="dialogLoader">
          <v-card-text class="body-2">
            <v-icon left color="primary">mdi-emoticon-cool-outline</v-icon>{{ item.fullName }}
            tem seu <span class="font-weight-black">1000º</span> treino conosco hoje! Dê os parabéns! 
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card class="elevation-10 mb-2" :disabled="dialogLoader">
          <v-card-title class="">Insights da Plataforma</v-card-title>
          <v-card-text>
            <v-select
              :items="daysItems"
              v-model="days"
              item-text="title"
              item-value="value"
              label="Período"
              @change="loadAllInsights"
            ></v-select>
          </v-card-text>
        </v-card>
      </v-col>
      
      <!-- Insight 1: User with Most Treinos (Overall) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userAvgTrainingsPerWeek" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-trophy-award</v-icon>Média de Treinos/Semana
          </v-card-title>
          <v-card-subtitle class="ml-4 ml-sm-10 pb-0">
            <span class="font-weight-black">Top 5</span>
          </v-card-subtitle>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item-group>
                <v-list-item v-for="user in userAvgTrainingsPerWeek.slice(0, 5)" :key="user.userId">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ user.fullName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Média: {{ user.avgTrainingsPerWeek.toFixed(1) }} treinos/semana
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <!-- Insight 2: Média de Treinos/Semana (Corrida) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userAvgTrainingsPerWeekCorrida" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-run</v-icon>Média de Treinos/Semana (Corrida)
          </v-card-title>
          <v-card-subtitle class="ml-4 ml-sm-10 pb-0">
            <span class="font-weight-black">Top 5</span>
          </v-card-subtitle>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item-group>
                <v-list-item v-for="user in userAvgTrainingsPerWeekCorrida.slice(0, 5)" :key="user.userId">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ user.fullName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Média: {{ user.avgTrainingsPerWeek.toFixed(1) }} treinos/semana
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <!-- Insight 3: Média de Treinos/Semana (Ciclismo) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userAvgTrainingsPerWeekCiclismo" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-bicycle</v-icon>Média de Treinos/Semana (Ciclismo)
          </v-card-title>
          <v-card-subtitle class="ml-4 ml-sm-10 pb-0">
            <span class="font-weight-black">Top 5</span>
          </v-card-subtitle>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item-group>
                <v-list-item v-for="user in userAvgTrainingsPerWeekCiclismo.slice(0, 5)" :key="user.userId">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ user.fullName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Média: {{ user.avgTrainingsPerWeek.toFixed(1) }} treinos/semana
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

      <!-- Insight 4: Média de Treinos/Semana (Natação) -->
      <v-col cols="12" md="6" lg="4" xl="3" v-if="userAvgTrainingsPerWeekNatacao" :disabled="dialogLoader">
        <v-card class="elevation-10" dense>
          <v-card-title class="font-weight-black body-2">
            <v-icon left class="d-none d-md-flex">mdi-swim</v-icon>Média de Treinos/Semana (Natação)
          </v-card-title>
          <v-card-subtitle class="ml-4 ml-sm-10 pb-0">
            <span class="font-weight-black">Top 5</span>
          </v-card-subtitle>
          <v-card-text class="body-1">
            <v-list dense>
              <v-list-item-group>
                <v-list-item v-for="user in userAvgTrainingsPerWeekNatacao.slice(0, 5)" :key="user.userId">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ user.fullName }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Média: {{ user.avgTrainingsPerWeek.toFixed(1) }} treinos/semana
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-col>

    </v-row>

    <!-- Loader for insights -->
    <div class="text-center">
      <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-5">
            Loading insights...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
    </v-dialog>
    </div>
  </v-container>
</template>


<script>
import HOST from '@/ws'

export default {
  data() {
    return {
      dialogLoader: false,
      userAvgTrainingsPerWeek: null,
      userAvgTrainingsPerWeekCorrida: null,
      userAvgTrainingsPerWeekCiclismo: null,
      userAvgTrainingsPerWeekNatacao: null,
      days: 30,

      userWithTreinosByCount100 : null,
      userWithTreinosByCount500 : null,
      userWithTreinosByCount1000 : null,

      daysItems: [
        { title: 'Últimos 30 dias', value: 30 },
        { title: 'Últimos 90 dias', value: 90 },
        { title: '6 meses', value: 182 },
        { title: '1 ano', value: 365 },
      ]
    };
  },

  beforeMount(){
    this.loadAllInsights();
  },

  methods: {

    // Method that loads all insights
    async loadAllInsights() {
      try {
        this.dialogLoader = true;

        const config = {
          headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
        };

        // Fetch insight for user average trainings per days
        let response = await this.axios.get(HOST.HOST + '/api/insights/avg-trainings-per-week?days=' + this.days, config);
        this.userAvgTrainingsPerWeek = response.data;
        
        // Fetch insight for user average (Corrida)
        response = await this.axios.get(HOST.HOST + '/api/insights/avg-trainings-per-week-sport?days=' + this.days + "&esporte=Corrida", config);
        this.userAvgTrainingsPerWeekCorrida = response.data;

        // Fetch insight for user average (Ciclismo)
        response = await this.axios.get(HOST.HOST + '/api/insights/avg-trainings-per-week-sport?days=' + this.days + "&esporte=Ciclismo", config);
        this.userAvgTrainingsPerWeekCiclismo = response.data;

        // Fetch insight for user average (Natação)
        response = await this.axios.get(HOST.HOST + '/api/insights/avg-trainings-per-week-sport?days=' + this.days + "&esporte=Natação", config);
        this.userAvgTrainingsPerWeekNatacao = response.data;

        // Fetch users with the 100th treino
        response = await this.axios.get(HOST.HOST + '/api/insights/users-by-treino-count?treinoCount=100', config);
        this.userWithTreinosByCount100 = response.data;
        console.log('\n natação: \n' + JSON.stringify(response.data));

        // Fetch users with the 500th treino
        response = await this.axios.get(HOST.HOST + '/api/insights/users-by-treino-count?treinoCount=500', config);
        this.userWithTreinosByCount500 = response.data;
        console.log('\n natação: \n' + JSON.stringify(response.data));

        // Fetch users with the 1000th treino
        response = await this.axios.get(HOST.HOST + '/api/insights/users-by-treino-count?treinoCount=1000', config);
        this.userWithTreinosByCount1000 = response.data;
        console.log('\n natação: \n' + JSON.stringify(response.data));

      } catch (error) {
        console.error('Error loading insights data:', error);
        this.$store.commit("logout");
        this.$router.push("/");
      } finally {
        this.dialogLoader = false;
      }
    },
  },
};
</script>
